<template>
  <!-- 导入日记账 -->
  <el-dialog
    title="导入日记账" :visible.sync="importFiles" width="600px" :close-on-click-modal="false" class='RJZ_dialog'>
    <div v-loading='isImportFilesLoading' element-loading-text="正在上传文件...">
      <div class="fliesUplaod"  >
        <div class='stepOne'>
            <h4 class='color333'>步骤1：配置自定义表单</h4>
            <p>您需要先配置好您的表单内容：点击“添加日记账”-“配置表单”设置所需自定义列；</p>
        </div>
        <div class='stepTwo'>
            <h4 class='color333'>步骤2：导出模板</h4>
            <p>按当前自定义表单导出模板：<el-button type="text" class='handleDownload' @click='rjz_handleDownload_MB'>点击下载模板</el-button></p>
        </div>
        <div class='stepThree'>
             <h4 class='color333'>步骤3：导入表单</h4>
               <div class="uploads">
                  <el-upload
                    drag
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list='true'
                    :auto-upload="false"
                    :on-change="OnChange"
                    :on-remove="OnRemove"
                    :before-remove="beforeRemove"
                    :limit='handleLimit'
                    ref='upload'
                    >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传.xls/.xlsx文件，且不超过5M</div>
                  </el-upload>
                </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" class='minButton' @click="handleUploadAdd">确定导入</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        isImportFilesLoading:false,
        importFiles:false,
        fileList:[],
        handleLimit: 1,        // 上传文件数
      }
    },
    methods:{
      // 导入成功
      importSuccess() {
         this.$refs.upload.clearFiles();
         this.fileList = [];
         this.importFiles = false;
      },
      // 下载模板
      rjz_handleDownload_MB() {
        let cid=sessionStorage.getItem('cid');
        let token=sessionStorage.getItem('token');
        window.location.href = this.$rootUrl+'export/downImportTemplate?cid='+cid+'&token='+token + "&templateName=日记账导入模板.xlsx";
      },
      // 传入文件监听
      OnChange(file,fileList){
        this.fileList=fileList
      },
      // 移出操作
      OnRemove(file,fileList){
        this.fileList=fileList
      },
      // 移出提示
      beforeRemove(file, fileList) {
         return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handleUploadAdd() {
        this.$emit("import",this.fileList)
      },
    }
  }
</script>

<style lang="less">
  .RJZ_dialog {
    .el-dialog {
      .el-dialog__header {
        padding: 17px 20px;
        border-bottom: 1px solid #E5E5E5;
        .el-dialog__title {
          color: #333;
          font-size: 14px;
          font-weight: 600;
        }

      }
      .dialog-footer {
        text-align: right;
      }
      .el-dialog__body {
            padding: 18px 20px;
      }
      .fliesUplaod{
        .fliesUplaod_text {
          color: #EC681D;
          display: inline-block;
          margin-bottom: 20px;
        }
        .handleDownload {
          margin: 3px 0 18px 0;
        }
        .uploads{
          padding:15px 0px;
          .el-upload-dragger {
            width: 250px;
            height: 90px;
            .el-icon-upload {
              font-size: 35px;
              margin: 0;
              line-height: 45px;
            }
          }
        }

        /*new*/
        .stepOne {
          p {
            margin-top: 10px;
            margin-left: 30px;
          }
        }
        .stepTwo {
          margin-top: 20px;
          p{
            margin-left: 30px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/c-query-table/c-import.vue